interface IProgressBarSegment {
    id: string;
    value: number;
    color: string;
    tooltip?: string;
}

interface IProgressBar {
    segments: IProgressBarSegment[];
    total: number;
}

export const ProgressBar = ({ segments, total }: IProgressBar) => {
    return (
        <div className="progress-bar">
            {segments.map(segment => {
                if (!segment.value) return null;

                const widthPercentage = (segment.value / total) * 100;
                return (
                    <div key={segment.id} style={{ width: `${widthPercentage}%`, backgroundColor: segment.color }} className="progress-bar__line">
                        {segment.tooltip && <p className="paragraph-5 progress-bar__line--tooltip">{segment.tooltip}</p>}
                    </div>
                );
            })}
        </div>
    );
};
